// import React, { useState, useEffect } from 'react';
// // import Navbar from '../navbar/Navbar';
// import AdminNav from '../navbar/AdminNav';
// import { Outlet } from 'react-router-dom';
// // import AdminHome from '../pages/AdminPannel/dashboard/Dashboard';
// // import AdminHome from '../home/AdminHome';
// import TopBar from '../navbar/TopNav'
// function AdminLayout() {
//     const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
//     const [isMobile, setIsMobile] = useState(window.innerWidth < 576);
//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//     useEffect(() => {
//         const handleResize = () => {
//             setIsMobile(window.innerWidth < 576);
//         };
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     const collapseSidenav = () => {
//         if (isMobile) {
//             setMobileMenuOpen(!mobileMenuOpen);
//         } else {
//             setIsSidebarCollapsed(!isSidebarCollapsed);
//         }
//     }
//     return (
//         <div className='d-flex h-[100vh]'>
//             <AdminNav isSidebarCollapsed={isSidebarCollapsed} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
//             <div
//                 style={{
//                     width: "100%",
//                     transition: 'width 0.3s ease',
//                     overflow: 'hidden',
//                     backgroundColor: '#fcfefd',

//                 }}>
//                 <TopBar collapseSidenav={collapseSidenav} />
//                 <Outlet />
//             </div>
//         </div>
//     )
// }

// export default AdminLayout


import React, { useState, useEffect } from 'react';
import AdminNav from '../navbar/AdminNav';
import { Outlet, Navigate } from 'react-router-dom'; // Navigate import करें
import TopBar from '../navbar/TopNav';

function AdminLayout() {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 576);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    
    // Simple check for admin token
    const isAdminAuthenticated = !!localStorage.getItem('adminToken');

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 576);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const collapseSidenav = () => {
        if (isMobile) {
            setMobileMenuOpen(!mobileMenuOpen);
        } else {
            setIsSidebarCollapsed(!isSidebarCollapsed);
        }
    }
    
    // If not authenticated, redirect to admin login
    if (!isAdminAuthenticated) {
        return <Navigate to="/admin-login" replace />;
    }

    return (
        <div className='flex h-[100vh]'>
            <AdminNav isSidebarCollapsed={isSidebarCollapsed} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
            <div
                style={{
                    width: "100%",
                    transition: 'width 0.3s ease',
                    overflow: 'hidden',
                    backgroundColor: '#fcfefd',
                }}>
                <TopBar collapseSidenav={collapseSidenav} />
                <Outlet />
            </div>
        </div>
    )
}

export default AdminLayout;